import axios from 'axios'
import { ENDPOINTS } from '@/config/endpoints'

// Fire LP pixel if we have a request ID
export function fireLpPixel(lpRequestId) {
  if (!lpRequestId) return

  axios.post(ENDPOINTS.LP_PIXEL + lpRequestId).catch(() => {
    console.log('LP pixel fire failed (silent)')
  })
}

// Initialize TrustedForm script
export function initTrustedForm() {
  const field = 'xxTrustedFormCertUrl'
  const provideReferrer = false
  const invertFieldSensitivity = false

  const tf = document.createElement('script')
  tf.type = 'text/javascript'
  tf.async = true
  tf.defer = true
  tf.src = 'https://api.trustedform.com/trustedform.js?provide_referrer=' + escape(provideReferrer) +
    '&field=' + escape(field) + '&l=' + new Date().getTime() + Math.random() +
    '&invert_field_sensitivity=' + invertFieldSensitivity

  console.log('TrustedForm: Loading script from', tf.src)

  const s = document.getElementsByTagName('script')[0]
  s.parentNode.insertBefore(tf, s)

  console.log('TrustedForm: Script inserted into DOM')
}

// Initialize RedTrack pixel and return click ID
export function initRedTrackPixel(campaignId) {
  return new Promise((resolve) => {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = true
    script.src = `https://trkr.firstadvantage.io/uniclick.js?attribution=lastpaid&cookiedomain=&cookieduration=7&defaultcampaignid=${campaignId}&regviewonce=false`

    script.onload = function() {
      // Wait a brief moment for the script to set the click ID
      setTimeout(() => {
        // Try to get click ID from session storage, global var, or cookie
        const clickId = sessionStorage.getItem('rtkclickid') ||
                        window.rtkClickID ||
                        getCookieValue('rtkclickid-store')

        console.log('RedTrack: Click ID retrieved:', clickId)
        resolve(clickId || null)
      }, 500)
    }

    script.onerror = function() {
      console.error('RedTrack: Failed to load script')
      resolve(null)
    }

    document.getElementsByTagName('head')[0].appendChild(script)
    console.log('RedTrack: Script loading from', script.src)
  })
}

// Helper to get cookie value
function getCookieValue(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
  return match ? match[2] : null
}

export const pixelService = {
  fireLpPixel,
  initTrustedForm,
  initRedTrackPixel
}
